import React from 'react'
import { Description, Field, Label, Select } from '@headlessui/react'
import { cx } from 'class-variance-authority'
import { useApplyFormStore } from '../../stores/ui/applyFormStore'
import { ErrorMessage } from '../ui/form/ErrorMessage'

interface ContractTypeSelectorProps {
  error?: string
  name?: string
  description?: string
}

export const ContractTypeSelector = ({
  error,
  name,
  description,
}: ContractTypeSelectorProps) => {
  const isDirty = useApplyFormStore((state) => state.isDirty)
  const { setFieldValue } = useApplyFormStore()

  const contractTypes = [
    { id: 'CDI', name: 'CDI' },
    { id: 'CDD', name: 'CDD' },
    { id: 'Stage', name: 'Stage' },
    { id: 'Alternance', name: 'Alternance' },
    { id: 'Freelance', name: 'Indépendant' },
  ]

  return (
    <Field className="flex flex-col space-y-2">
      <Label className="font-medium text-night text-sm/6">
        Quel type de contrat recherchez-vous ?
      </Label>
      {description && <Description>{description}</Description>}
      <Select
        value={useApplyFormStore((state) => state.contractType) || undefined}
        name={name}
        className={cx(
          'bg-white border-2 border-gray-200 rounded-xl disabled:cursor-not-allowed placeholder:text-sm text-sm focus:outline-none focus-visible:outline-none focus:ring-0 focus-visible:ring-0 relative placeholder:text-night/60 text-night',
          Boolean(error) && 'border-red-300',
        )}
        onChange={(e) => setFieldValue('contractType', e.target.value)}
      >
        {contractTypes.map((contractType) => (
          <option key={contractType.id} value={contractType.id}>
            {contractType.name}
          </option>
        ))}
      </Select>
      {isDirty && <ErrorMessage error={error} />}
    </Field>
  )
}
